export default {
  name: 'projects',
  components: {},
  props: [],
  data() {
    return {}
  },
  computed: {
    projects() {
      return this.$store.state.projects
    }
  },
  mounted() {

  },
  methods: {

  }
}